import { ReactElement } from 'react';

import { IconsPropsI } from './interfaces';

const CreditCard = ({ width = 40, height = 40 }: IconsPropsI): ReactElement => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="9.5" width="32.25" height="21.5" rx="4" fill="#3A74F8" />
      <rect x="4" y="13.9805" width="32.25" height="3.58333" fill="#204FCC" />
      <path
        d="M19.8314 24.2799H7.39875C7.00045 24.2799 6.6875 23.8858 6.6875 23.3841C6.6875 22.8824 7.00045 22.4883 7.39875 22.4883H19.8314C20.2297 22.4883 20.5427 22.8824 20.5427 23.3841C20.5427 23.8858 20.2297 24.2799 19.8314 24.2799Z"
        fill="#CFDFFC"
      />
      <path
        d="M12.9749 27.1354H7.39875C7.00045 27.1354 6.6875 26.7412 6.6875 26.2396C6.6875 25.7379 7.00045 25.3438 7.39875 25.3438H12.9749C13.3732 25.3438 13.6862 25.7379 13.6862 26.2396C13.6862 26.7412 13.3732 27.1354 12.9749 27.1354Z"
        fill="#CFDFFC"
      />
      <ellipse cx="31.1917" cy="24.7303" rx="2.67996" ry="2.68731" fill="#F9D222" />
      <ellipse cx="27.6253" cy="24.7303" rx="2.67996" ry="2.68731" fill="#FDEA7A" />
    </svg>
  );
};

export default CreditCard;
